import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Error from '../components/Error';


function Contact() {
  return (
    <div>
      {/* <Header />
      <Footer /> */}
      <Error />
    </div>
  )
}

export default Contact